import React from "react";
import Skeleton from "react-loading-skeleton";
import "./MyAnalytics.css";

const MyAnalyticsSkeleton = () => {
  return (
    <div style={{ padding: "20px" }}>
      {/* -------- Top Section -------- */}
      <div style={{ marginBottom: "30px" }}>
        <Skeleton width={200} height={25} />
      </div>

      <div style={{ display: "flex", gap: "20px", marginBottom: "30px" }}>
        {/* Left: circle placeholder */}
        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <Skeleton circle width={120} height={120} />
        </div>

        {/* Middle: Daily Goals */}
        <div style={{ flex: 2 }}>
          <Skeleton width={120} height={20} />
          {[1, 2, 3].map((i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", marginTop: 15 }}>
              <Skeleton circle width={40} height={40} />
              <div style={{ marginLeft: 12 }}>
                <Skeleton width={80} height={20} />
                <Skeleton width={100} height={15} />
              </div>
            </div>
          ))}
        </div>

        {/* Right: Coins + Streak */}
        <div style={{ flex: 1 }}>
          {[1, 2].map((i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", marginBottom: 15 }}>
              <Skeleton circle width={40} height={40} />
              <div style={{ marginLeft: 12 }}>
                <Skeleton width={60} height={20} />
                <Skeleton width={80} height={15} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* -------- Bottom Section -------- */}
      <div>
        <Skeleton width={200} height={25} />
        <div style={{ marginTop: 20 }}>
          <Skeleton height={250} borderRadius={12} />
        </div>

        <div style={{ display: "flex", gap: "20px", marginTop: 20 }}>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Skeleton circle width={15} height={15} />
              <Skeleton width={60} height={15} />
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
          <Skeleton width={150} height={40} borderRadius={20} />
        </div>
      </div>
    </div>
  );
};

export default MyAnalyticsSkeleton;
